import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    label: {
      margin: theme.spacing(2)
    },
    placeholder: {
      height: 40
    }
  })
)
